import { ColumnOptions } from '../types/column-options';
import { NumberColumn } from '../types/grid';
import { ColumnHostRef } from '../types/refs';

export interface PercentColumnOptions<TRow extends object>
  extends ColumnOptions<TRow, number> {
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
}

// Percent value (discount, margin %, …): a number column whose default format
// appends ` %` (the format string's numeric part is replaced, the suffix stays).
// Uses the existing `number` column type so query handling stays identical.
export function percentColumn<TRow extends object>(
  ref: ColumnHostRef<TRow>,
  options: PercentColumnOptions<TRow>
): NumberColumn<TRow> {
  const column: NumberColumn<TRow> = {
    ...options,
    type: 'number',
    format: options.format ?? 'PERCENT.DEFAULT',
  };
  ref.createColumn(column);
  return column;
}
